module.exports = __webpack_public_path__ + "static/Barcode-e36ea1a362990c258325daf265df9a12.png";